import { parseAsBoolean, useQueryState } from "nuqs";

import { Button } from "~/common/components";
import Modal from "~/common/components/Modal";

export const DeviceOptimizationModal = () => {
  const [showDisclaimer, setShowDisclaimer] = useQueryState(
    "disclaimer",
    parseAsBoolean.withDefault(false),
  );

  return (
    <Modal
      title="Optimized for Desktop or Tablet"
      onClose={() => setShowDisclaimer(false)}
      show={showDisclaimer}
      className="max-w-lg md:hidden"
      overlayClassName="md:hidden"
    >
      <p>
        For the best experience we recommend accessing PsychNow from a desktop
        or tablet device.
      </p>
      <Button onClick={() => setShowDisclaimer(false)} type="button">
        Got it
      </Button>
    </Modal>
  );
};
